import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NotAuthenticatedUserError } from '@errors/error';
import { AuthService } from '@services/auth.service';
import { SystemAdminService } from '@services/system-admin.service';

export const tenantGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const systemAdminService = inject(SystemAdminService);

  const loggedInUser = authService.loggedInUser;
  if (!loggedInUser) {
    throw new NotAuthenticatedUserError();
  }
  const role = loggedInUser.tenant.roleId;

  /**
   * マクニカ管理者の場合
   * ①マクニカ管理者テナントを選択していれば、デバイス一覧画面へ
   * ②テナントが選択されていなければ、選択画面へ
   *
   * それ以外はそのまま通す
   */
  if (role === 'system_admin') {
    if (systemAdminService.isSelectedSystemAdminTenant) {
      return router.parseUrl('/devices');
    } else if (!systemAdminService.isSelectedTenant) {
      return router.parseUrl('/tenant-select');
    }
  }

  return true;
};
